import {DvirQuestion} from './dvir-question';
import {DvirItem} from './dvir-item';

export class DvirGroup extends DvirItem {
  id?: number;
  title?: string;
  hasRemarks = false;

  questions: DvirQuestion[] = [];

  constructor(questions: DvirQuestion[] = []) {
    super();
    this.questions = questions;
  }

}
